import { useState } from "react";
import "../index.css";
import Footer from "../components/Footer";
import { PageNav } from "../components/PageNav";
import { useNavigate } from "react-router-dom";
import buttonBackground from "../assets/button_background_blue.webp";

interface HelpSection {
  id: string;
  title: string;
  icon: string;
  content: React.ReactElement;
}

export default function Help() {
  const navigate = useNavigate();
  const [expandedSection, setExpandedSection] = useState<string | null>("");

  const toggleSection = (sectionId: string) => {
    setExpandedSection(expandedSection === sectionId ? null : sectionId);
  };

  const helpSections: HelpSection[] = [
    // {
    //   id: "getting-started",
    //   title: "Getting Started",
    //   icon: "🚀",
    //   content: (
    //     <div>
    //       <h3
    //         className="font_family_base"
    //         style={{ fontSize: 18, marginBottom: 15 }}
    //       >
    //         Welcome to StakeAlerts!
    //       </h3>
    //       <p
    //         className="font_family_base"
    //         style={{ marginBottom: 15, lineHeight: 1.6 }}
    //       >
    //         StakeAlerts helps you track live sports betting odds across multiple
    //         sportsbooks and receive custom notifications when your preferred
    //         betting opportunities arise.
    //       </p>
    //       <div style={{ marginBottom: 15 }}>
    //         <h4
    //           className="font_family_base"
    //           style={{ fontSize: 16, marginBottom: 10 }}
    //         >
    //           Quick Start Steps:
    //         </h4>
    //         <ol
    //           className="font_family_base"
    //           style={{ paddingLeft: 20, lineHeight: 1.8 }}
    //         >
    //           <li>
    //             <strong>Subscribe to a Plan:</strong> Choose a subscription plan
    //             that fits your needs
    //           </li>
    //           <li>
    //             <strong>Browse Games:</strong> View live odds for current and
    //             upcoming games
    //           </li>
    //           <li>
    //             <strong>Create Rules:</strong> Set up custom alerts for betting
    //             opportunities
    //           </li>
    //           <li>
    //             <strong>Get Notified:</strong> Receive alerts when odds match
    //             your criteria
    //           </li>
    //         </ol>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      id: "viewing-games",
      title: "Viewing Live Games & Odds",
      icon: "📊",
      content: (
        <div>
          <h3
            className="font_family_base"
            style={{ fontSize: 18, marginBottom: 15 }}
          >
            "Active Games" Page
          </h3>
          <div style={{ marginBottom: 15 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Games Page Features
            </div>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>
                <strong>Filter by Sport:</strong> Use the Sport dropdown to view
                specific sports
              </li>
              <li>
                <strong>Sportsbook:</strong> Select a specific sportsbook to see
                their odds
              </li>
              <li>
                <strong>Current vs Upcoming:</strong> Toggle between games
                happening now and future games
              </li>
              <li>
                <strong>Alerts Only:</strong> Filter to show only games with
                active alerts
              </li>
              <li>
                <strong>My Games Only:</strong> View games with associated rules
              </li>
              <li>
                <strong>Alert Highlight:</strong> Games where one of your rules
                has triggered are outlined so they stand out
              </li>
            </ul>
          </div>
          <div style={{ marginBottom: 15 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Understanding Odds
            </div>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>
                <strong>Spread:</strong> Point handicap betting (e.g., Team A
                -3.5)
              </li>
              <li>
                <strong>Over/Under:</strong> Total points scored betting
              </li>
              <li>
                <strong>Moneyline:</strong> Straight-up winner betting
              </li>
            </ul>
          </div>
          <div style={{ marginBottom: 15 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              View Charts & Props
            </div>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>
                <strong>📊:</strong> Click to view live odds movement charts for that game (spread, total, moneyline)
              </li>
              <li>
                <strong>🗝️ (Pro):</strong> Click to open the Game Props page with every prop line for that game
              </li>
            </ul>
          </div>
          <button
            onClick={() => navigate("/games")}
            className="my-form-button button-base button-3d font_family_base"
            style={{
              backgroundImage: `url(${buttonBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
              fontWeight: 700,
              marginTop: 10,
              width: "200px",
            }}
          >
            Go to Games →
          </button>
        </div>
      ),
    },
    {
      id: "game-details",
      title: "Game Charts, Game Props & Prop Charts",
      icon: "📈",
      content: (
        <div>
          <h3
            className="font_family_base"
            style={{ fontSize: 18, marginBottom: 15 }}
          >
            Game Charts (📊)
          </h3>
          <p
            className="font_family_base"
            style={{ marginBottom: 15, lineHeight: 1.6 }}
          >
            Click the 📊 icon on any game to see how odds have moved over time.
          </p>
          <div style={{ marginBottom: 20 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Game Chart Features
            </div>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>
                <strong>Bet Type Dropdown:</strong> Switch between Over/Under, Spread (Away/Home), and Moneyline (Away/Home). Over/Under also has Over Price and Under Price, and each Spread side has a Price view, to chart the odds instead of the line. Soccer games chart Moneyline (Home), (Draw), and (Away)
              </li>
              <li>
                <strong>Multi-Book Overlay:</strong> All tracked sportsbooks plotted on the same chart
              </li>
              <li>
                <strong>Live Updates:</strong> Charts refresh automatically every 5 seconds during live games
              </li>
              <li>
                <strong>Game Switcher:</strong> Tap the team name at the top to jump to a different game
              </li>
            </ul>
          </div>
          <h3
            className="font_family_base"
            style={{ fontSize: 18, marginBottom: 15, marginTop: 20 }}
          >
            Game Props Page (🗝️) — Pro
          </h3>
          <p
            className="font_family_base"
            style={{ marginBottom: 15, lineHeight: 1.6 }}
          >
            Click the 🗝️ icon on any game (Pro and above) to see every prop line
            for that game across the tracked sportsbooks.
          </p>
          <div style={{ marginBottom: 20 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Game Props Features
            </div>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>
                <strong>Main Odds, Game Odds & Player Odds:</strong> Collapsible sections for the main lines, game-level props, and individual player props
              </li>
              <li>
                <strong>Alert Highlight:</strong> A section is highlighted when one of your rules has triggered on a line inside it
              </li>
              <li>
                <strong>📊 Chart Links:</strong> Click 📊 next to any line to open its chart
              </li>
              <li>
                <strong>Pre-Game Odds:</strong> Before live odds are posted, the page shows the pre-game lines and says so
              </li>
            </ul>
          </div>
          <h3
            className="font_family_base"
            style={{ fontSize: 18, marginBottom: 15, marginTop: 20 }}
          >
            Prop Charts — Pro
          </h3>
          <p
            className="font_family_base"
            style={{ marginBottom: 15, lineHeight: 1.6 }}
          >
            Click 📊 next to a line on the Game Props page to chart how that
            prop has moved.
          </p>
          <div style={{ marginBottom: 15 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Prop Chart Features
            </div>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>
                <strong>Prop Selector:</strong> Dropdown to choose any available game prop or player prop
              </li>
              <li>
                <strong>Side & Price Views:</strong> Where a prop has more than one side, or an over/under price, extra dropdowns let you chart each one
              </li>
              <li>
                <strong>Game Switcher:</strong> Tap the matchup at the top to jump to a different game
              </li>
              <li>
                <strong>Game & Player Props:</strong> Covers both team-level totals (e.g., first 5 innings runs) and individual player props
              </li>
              <li>
                <strong>Live Updates:</strong> Prop odds refresh every 5 seconds
              </li>
            </ul>
          </div>
        </div>
      ),
    },
    {
      id: "advantage-betting",
      title: "Advantage Betting (Arb & EV)",
      icon: "⚡",
      content: (
        <div>
          <h3
            className="font_family_base"
            style={{ fontSize: 18, marginBottom: 15 }}
          >
            "Advantage Betting" Page — Premium
          </h3>
          <p
            className="font_family_base"
            style={{ marginBottom: 15, lineHeight: 1.6 }}
          >
            The Advantage Betting page surfaces real-time arbitrage and positive expected value (+EV) opportunities across all tracked sportsbooks.
          </p>
          <div style={{ marginBottom: 20 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Arbitrage (Arb)
            </div>
            <p
              className="font_family_base"
              style={{ marginBottom: 10, lineHeight: 1.6 }}
            >
              Arb opportunities let you lock in a guaranteed profit by betting both sides of a market at different sportsbooks. Each card shows:
            </p>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li><strong>Profit %:</strong> The guaranteed return on your total stake</li>
              <li><strong>Est. Net:</strong> The odds provider's estimated net profit percentage</li>
              <li><strong>Implied:</strong> The combined implied probability of all legs (under 100% means an arb exists)</li>
              <li><strong>Legs:</strong> Which sportsbook to bet and at what odds for each side</li>
              <li><strong>Stake %:</strong> How to split your total stake across each leg to lock in the profit</li>
              <li><strong>Stake Calculator:</strong> Enter your total stake and the per-book dollar amounts are computed automatically</li>
            </ul>
          </div>
          <div style={{ marginBottom: 20 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Positive EV (+EV)
            </div>
            <p
              className="font_family_base"
              style={{ marginBottom: 10, lineHeight: 1.6 }}
            >
              +EV bets are priced better than their true probability suggests, giving you a mathematical edge over the long run. Each card shows:
            </p>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li><strong>EV %:</strong> Expected value as a percentage of stake</li>
              <li><strong>Kelly %:</strong> Suggested bet size as a fraction of bankroll</li>
              <li><strong>Confidence & Tier:</strong> How reliable the edge estimate is</li>
              <li><strong>No-Vig Odds & Fair Probability:</strong> The sharp market's true price</li>
              <li><strong>Market Width:</strong> How tight the market is (tighter = sharper)</li>
            </ul>
          </div>
          <div style={{ marginBottom: 15 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Filters
            </div>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li><strong>Arb / EV toggle:</strong> Switch between opportunity types</li>
              <li><strong>Live / Upcoming toggle:</strong> Filter to in-progress or pregame opportunities</li>
              <li><strong>Sport picker:</strong> Narrow to a specific sport</li>
              <li><strong>EV % and No-Vig ranges (EV only):</strong> Set a minimum and/or maximum to narrow the list</li>
            </ul>
          </div>
          <div style={{ marginBottom: 15 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Card Badges
            </div>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li><strong>LIVE:</strong> The game is in progress</li>
              <li><strong>ALT LINE:</strong> Uses an alternate line rather than the main line</li>
              <li><strong>PROP:</strong> A player prop market</li>
              <li><strong>STALE:</strong> The odds may be out of date — confirm them at the sportsbook before betting</li>
            </ul>
          </div>
          <button
            onClick={() => navigate("/advantage")}
            className="my-form-button button-base button-3d font_family_base"
            style={{
              backgroundImage: `url(${buttonBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
              fontWeight: 700,
              marginTop: 10,
              width: "220px",
            }}
          >
            Go to Advantage Betting →
          </button>
        </div>
      ),
    },
    {
      id: "creating-rules",
      title: "Creating Alert Rules",
      icon: "🔔",
      content: (
        <div>
          <h3
            className="font_family_base"
            style={{ fontSize: 18, marginBottom: 15 }}
          >
            "Create Rule" Page
          </h3>
          <p
            className="font_family_base"
            style={{ marginBottom: 15, lineHeight: 1.6 }}
          >
            Alert rules notify you when odds match your specific criteria.
          </p>
          <div style={{ marginBottom: 20 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Rule Types by Plan
            </div>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>
                <strong>Basic & above — Game rules:</strong> Spread, Over/Under, Moneyline alerts for standard game lines
              </li>
              <li>
                <strong>Pro & above — Prop rules:</strong> Game prop and player prop alerts (e.g., alert when a player's points line crosses a threshold)
              </li>
              <li>
                <strong>Premium — Arb & EV rules:</strong> Set a minimum net profit (Arb) or EV percentage, and get notified when an opportunity at or above that threshold appears for your chosen sport/teams
              </li>
            </ul>
          </div>
          <div style={{ marginBottom: 15 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              How to Create a Rule
            </div>
            <ol
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>Choose a rule type, select your sport, and name your rule</li>
              <li>
                Select the conferences, divisions, or specific teams to follow
                (for player prop rules, select the players)
              </li>
              <li>Select which sportsbooks to monitor</li>
              <li>
                Pick the rule group and rule, then set your trigger conditions
                (e.g., "spread greater than 7")
              </li>
              <li>Optionally enable mobile push notifications</li>
              <li>Save your rule</li>
            </ol>
          </div>
          <div style={{ marginBottom: 15 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Setting Trigger Values
            </div>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>
                <strong>Moneyline & payout odds:</strong> Moneyline rules, and
                other rules priced in American odds (e.g., Both Teams Score, Race
                To 10, Odd/Even, Touchdown Scorer, and "Any" player props), use
                values of -100 or lower, or +100 or higher. The stepper jumps
                straight from +100 to -100
              </li>
              <li>
                <strong>Spreads:</strong> Spread targets can be negative
                (favorite), positive (underdog), or zero
              </li>
              <li>
                <strong>Lines & totals:</strong> Over/Under and other line
                values move in half-point steps
              </li>
              <li>
                <strong>Yes / No:</strong> For yes/no markets like Both Teams
                Score or Overtime, choose whether to watch the Yes or the No price
              </li>
              <li>
                <strong>Outcome selection:</strong> Multi-outcome markets like
                Halftime/Fulltime or Highest Scoring Half let you pick which
                outcomes the rule watches
              </li>
              <li>
                <strong>ⓘ Examples:</strong> Tap the "i" button next to the rule
                dropdown to see an example of how that rule works
              </li>
            </ul>
          </div>
          <div style={{ marginBottom: 15 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Rule Examples
            </div>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>Alert when any NBA spread exceeds +10.0 points</li>
              <li>Alert when an AFC East team's NFL over/under drops below 45.0</li>
              <li>Alert when any MLB moneyline reaches +200 or higher</li>
              <li>(Pro) Alert when a player's strikeout prop crosses 7.5</li>
              <li>(Premium) Alert when an arbitrage opportunity's net profit reaches 3% or higher in any MLB game</li>
              <li>(Premium) Alert when a +EV opportunity reaches 5% EV or higher in any NBA game</li>
            </ul>
          </div>
          <button
            onClick={() => navigate("/rule/create")}
            className="my-form-button button-base button-3d font_family_base"
            style={{
              backgroundImage: `url(${buttonBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
              fontWeight: 700,
              marginTop: 10,
              width: "200px",
            }}
          >
            Create a Rule →
          </button>
        </div>
      ),
    },
    {
      id: "my-rules",
      title: "My Rules",
      icon: "📋",
      content: (
        <div>
          <h3
            className="font_family_base"
            style={{ fontSize: 18, marginBottom: 15 }}
          >
            "My Rules" Page
          </h3>
          <p
            className="font_family_base"
            style={{ marginBottom: 15, lineHeight: 1.6 }}
          >
            The My Rules page shows all of your saved rules and lets you view,
            edit, enable/disable, or delete them.
          </p>
          <div style={{ marginBottom: 15 }}>
            <h4
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Navigating Your Rules
            </h4>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>
                <strong>Rule Selector:</strong> Tap the rule name at the top to
                open a side menu listing all of your rules — select any rule to
                view its details. Disabled rules are marked with a red
                "DISABLED" label in the list
              </li>
              <li>
                <strong>Rule Description:</strong> Displayed in green below the
                rule name, describing the alert condition being tracked. Yes/No
                rules also show which side is watched, and multi-outcome rules
                show the outcomes selected
              </li>
              <li>
                <strong>Sportsbooks:</strong> Shows which sportsbooks are
                monitored for this rule
              </li>
              <li>
                <strong>Teams / Players:</strong> Lists the specific teams (or
                players, for player prop rules) this rule applies to
              </li>
              <li>
                <strong>Notifications:</strong> Shows whether mobile push
                notifications are enabled for the rule
              </li>
            </ul>
          </div>
          <div style={{ marginBottom: 15 }}>
            <h4
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Rule Actions
            </h4>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>
                <strong>Edit:</strong> Modify the rule's conditions,
                sportsbooks, or teams
              </li>
              <li>
                <strong>Enable / Disable:</strong> Pause a rule without deleting
                it — a red "DISABLED" badge appears when the rule is off
              </li>
              <li>
                <strong>Delete:</strong> Permanently remove the rule after a
                confirmation prompt
              </li>
            </ul>
          </div>
          <p
            className="font_family_base"
            style={{ marginBottom: 15, lineHeight: 1.6 }}
          >
            <strong>Basic plan limit:</strong> Basic accounts can have up to 5
            rules. A banner appears when you reach the limit. If you have more
            than 5 (for example after moving down from Pro), you'll need to
            delete rules before you can use the other pages again.
          </p>
          <button
            onClick={() => navigate("/rules")}
            className="my-form-button button-base button-3d font_family_base"
            style={{
              backgroundImage: `url(${buttonBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
              fontWeight: 700,
              marginTop: 10,
              width: "200px",
            }}
          >
            Go to My Rules →
          </button>
        </div>
      ),
    },
    {
      id: "managing-subscription",
      title: "Managing Your Subscription",
      icon: "💳",
      content: (
        <div>
          <h3
            className="font_family_base"
            style={{ fontSize: 18, marginBottom: 15 }}
          >
            "Subscription Management" Page
          </h3>
          <p
            className="font_family_base"
            style={{ marginBottom: 15, lineHeight: 1.6 }}
          >
            Go to the user settings page by clicking on your username/avatar.
            Select "UPDATE" on your subscription.
          </p>
          <div style={{ marginBottom: 15 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Available Plans
            </div>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>
                <strong>Basic:</strong> Active games, game charts, and up to 5 alert rules (spread, total, moneyline)
              </li>
              <li>
                <strong>Pro:</strong> Everything in Basic, plus unlimited rules, prop betting charts (🗝️), and prop alert rule types
              </li>
              <li>
                <strong>Premium:</strong> Everything in Pro, plus Advantage Betting (real-time arb &amp; +EV opportunities) and arbitrage/EV alert rules
              </li>
            </ul>
          </div>
          <div style={{ marginBottom: 15 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              How to Update Your Subscription
            </div>
            <ol
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>Go to Settings from the navigation menu</li>
              <li>Click "UPDATE" in Subscription Plan</li>
              <li>Choose a new plan (Monthly or Annual), or cancel your subscription</li>
              <li>Confirm your selection</li>
            </ol>
          </div>
          <p
            className="font_family_base"
            style={{ marginBottom: 15, lineHeight: 1.6 }}
          >
            <strong>Downgrades</strong> take effect at the start of your next
            billing cycle — your pending plan is shown in Settings until then.
          </p>
          <p
            className="font_family_base"
            style={{ marginBottom: 15, lineHeight: 1.6 }}
          >
            <strong>Subscribed through the App Store or Google Play?</strong>{" "}
            Update or cancel your subscription from that store's account
            settings instead.
          </p>
          {/* <p
            className="font_family_base"
            style={{ marginBottom: 15, lineHeight: 1.6, color: "#666" }}
          >
            <strong>Note:</strong> When switching plans, changes take effect
            immediately. You will not lose access during your current billing
            period.
          </p> */}
          <button
            onClick={() => navigate("/settings")}
            className="my-form-button button-base button-3d font_family_base"
            style={{
              backgroundImage: `url(${buttonBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
              fontWeight: 700,
              marginTop: 10,
              width: "200px",
            }}
          >
            Go to Settings →
          </button>
        </div>
      ),
    },
    {
      id: "account-settings",
      title: "Account Settings",
      icon: "⚙️",
      content: (
        <div>
          <h3
            className="font_family_base"
            style={{ fontSize: 18, marginBottom: 15 }}
          >
            Managing Your Account
          </h3>
          <div style={{ marginBottom: 15 }}>
            <div
              className="font_family_base"
              style={{ fontSize: 16, color: "#4ade80", marginBottom: 10 }}
            >
              Account Settings Include
            </div>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>
                <strong>Profile Information:</strong> Update your
                username/avatar
              </li>
              <li>
                <strong>Subscription Details:</strong> View your current plan,
                any pending plan change, and when your trial or billing period
                ends
              </li>
              {/* <li>
                <strong>Notification Preferences:</strong> Manage how you
                receive alerts
              </li> */}
              <li>
                <strong>Password:</strong> For email/password accounts, tap
                "RESET" to receive a password reset email
              </li>
              <li>
                <strong>Signed-In Devices:</strong> See the devices signed in to
                your account (and your device limit), and sign out any device
                other than the one you're using
              </li>
              <li>
                <strong>Delete Account:</strong> Permanently delete your account
                and its data. If you have an active subscription, cancel it
                first to avoid future charges
              </li>
            </ul>
          </div>
          <button
            onClick={() => navigate("/settings")}
            className="my-form-button button-base button-3d font_family_base"
            style={{
              backgroundImage: `url(${buttonBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
              fontWeight: 700,
              marginTop: 10,
              width: "200px",
            }}
          >
            Go to Settings →
          </button>
        </div>
      ),
    },
    {
      id: "faq",
      title: "Frequently Asked Questions",
      icon: "❓",
      content: (
        <div>
          <h3
            className="font_family_base"
            style={{ fontSize: 18, marginBottom: 15 }}
          >
            Common Questions
          </h3>
          <div style={{ marginBottom: 20 }}>
            <h4
              className="font_family_base"
              style={{ fontSize: 15, marginBottom: 8 }}
            >
              Q: How often are odds updated?
            </h4>
            <p
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.6, color: "#999" }}
            >
              A: Odds are updated in real-time as they change across
              sportsbooks.
            </p>
          </div>
          <div style={{ marginBottom: 20 }}>
            <h4
              className="font_family_base"
              style={{ fontSize: 15, marginBottom: 8 }}
            >
              Q: Can I cancel my subscription anytime?
            </h4>
            <p
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.6, color: "#999" }}
            >
              A: Yes, you can cancel anytime. You'll retain access until the end
              of your billing period.
            </p>
          </div>
          <div style={{ marginBottom: 20 }}>
            <h4
              className="font_family_base"
              style={{ fontSize: 15, marginBottom: 8 }}
            >
              Q: Is there a free trial?
            </h4>
            <p
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.6, color: "#999" }}
            >
              A: Yes — new users get a 7-day free trial of the plan they choose.
            </p>
          </div>
          <div style={{ marginBottom: 20 }}>
            <h4
              className="font_family_base"
              style={{ fontSize: 15, marginBottom: 8 }}
            >
              Q: How many alert rules can I create?
            </h4>
            <p
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.6, color: "#999" }}
            >
              A: Basic plan is limited to 5 alert rules. Pro and Premium plans offer unlimited rules.
            </p>
          </div>
          <div style={{ marginBottom: 20 }}>
            <h4
              className="font_family_base"
              style={{ fontSize: 15, marginBottom: 8 }}
            >
              Q: What is Advantage Betting?
            </h4>
            <p
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.6, color: "#999" }}
            >
              A: Advantage Betting surfaces two types of profitable opportunities. Arbitrage (Arb) lets you bet both sides of a market at different sportsbooks to lock in a guaranteed profit regardless of outcome. Positive EV (+EV) identifies bets where the odds offered are better than the true probability, giving you a long-run mathematical edge. Both are available to Premium subscribers.
            </p>
          </div>
          <div style={{ marginBottom: 20 }}>
            <h4
              className="font_family_base"
              style={{ fontSize: 15, marginBottom: 8 }}
            >
              Q: Which sportsbooks do you track?
            </h4>
            <p
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.6, color: "#999" }}
            >
              A: We track odds from BetMGM, DraftKings, ESPNBet, Fanatics,
              FanDuel, Fliff, HardRockBet, Kalshi, Polymarket, PrizePicks, and
              Underdog. Not every book posts every market — for example,
              PrizePicks and Underdog only offer player props. We are happy to
              add more to our selection. Please contact us on the "Contact Us"
              page with your request.
            </p>
          </div>
          <div style={{ marginBottom: 20 }}>
            <h4
              className="font_family_base"
              style={{ fontSize: 15, marginBottom: 8 }}
            >
              Q: Do you place bets on my behalf?
            </h4>
            <p
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.6, color: "#999" }}
            >
              A: No, StakeAlerts is a tracking and notification service. We
              provide information to help you make informed decisions, but all
              betting is done through your own sportsbook accounts.
            </p>
          </div>
        </div>
      ),
    },
    {
      id: "contact",
      title: "Need More Help?",
      icon: "📧",
      content: (
        <div>
          <h3
            className="font_family_base"
            style={{ fontSize: 18, marginBottom: 15 }}
          >
            Contact Support
          </h3>
          <p
            className="font_family_base"
            style={{ marginBottom: 15, lineHeight: 1.6 }}
          >
            Can't find what you're looking for? Our support team is here to
            help!
          </p>
          {/* <div style={{ marginBottom: 15 }}>
            <h4
              className="font_family_base"
              style={{ fontSize: 16, marginBottom: 10 }}
            >
              Support Options:
            </h4>
            <ul
              className="font_family_base"
              style={{ paddingLeft: 20, lineHeight: 1.8 }}
            >
              <li>
                <strong>Email:</strong> Basic plan - Standard response time
              </li>
              <li>
                <strong>Priority Support:</strong> Pro plan - Faster response
              </li>
              <li>
                <strong>Dedicated Support:</strong> Premium plan - Direct line
                to our team
              </li>
            </ul>
          </div> */}
          <button
            onClick={() => navigate("/contact")}
            className="my-form-button button-base button-3d font_family_base"
            style={{
              backgroundImage: `url(${buttonBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
              fontWeight: 700,
              marginTop: 10,
            }}
          >
            Contact Us →
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <PageNav />
      <div className="main_div" style={{ paddingBottom: 40 }}>
        {/* Header */}
        <div
          className="center_me"
          style={{ paddingTop: 20, paddingBottom: 20 }}
        >
          <h1
            className="font_family_base header_text"
            style={{ fontSize: 28, marginBottom: 10 }}
          >
            Help Center
          </h1>
          {/* <p
            className="font_family_base"
            style={{ color: "#666", fontSize: 16 }}
          >
            Everything you need to know about using StakeAlerts
          </p> */}
        </div>

        {/* Help Sections - Accordion Style */}
        <div
          style={{
            width: "100%",
            padding: "0 40px",
          }}
        >
          {helpSections.map((section) => (
            <div
              key={section.id}
              style={{
                marginBottom: 15,
                border: "1px solid #333",
                borderRadius: "8px",
                overflow: "hidden",
                backgroundColor: "#000",
                boxSizing: "border-box",
                width: "100%",
              }}
            >
              {/* Section Header */}
              <button
                onClick={() => toggleSection(section.id)}
                className="font_family_base"
                style={{
                  width: "100%",
                  padding: "20px",
                  backgroundColor:
                    expandedSection === section.id ? "#1a1a1a" : "#000",
                  border: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontSize: 18,
                  fontWeight: "bold",
                  color: "white",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => {
                  if (expandedSection !== section.id) {
                    e.currentTarget.style.backgroundColor = "#0a0a0a";
                  }
                }}
                onMouseLeave={(e) => {
                  if (expandedSection !== section.id) {
                    e.currentTarget.style.backgroundColor = "#000";
                  }
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <span style={{ fontSize: 24 }}>{section.icon}</span>
                  <span>{section.title}</span>
                </div>
                <span
                  style={{
                    fontSize: 24,
                    transform:
                      expandedSection === section.id
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    transition: "transform 0.2s",
                  }}
                >
                  ▼
                </span>
              </button>

              {/* Section Content */}
              {expandedSection === section.id && (
                <div
                  style={{
                    padding: "20px",
                    borderTop: "1px solid #333",
                    backgroundColor: "#0a0a0a",
                    color: "#fff",
                  }}
                >
                  {section.content}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Quick Links */}
        {/* <div
          className="center_me"
          style={{
            marginTop: 40,
            padding: "20px",
            maxWidth: "800px",
            margin: "40px auto 0",
          }}
        >
          <div
            style={{
              backgroundColor: "#1a1a1a",
              padding: "30px",
              borderRadius: "12px",
              border: "1px solid #333",
            }}
          >
            <h3
              className="font_family_base center_me"
              style={{ fontSize: 20, marginBottom: 20 }}
            >
              Quick Navigation
            </h3>
            <div
              className="center_me"
              style={{
                display: "flex",
                gap: 15,
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              <button
                onClick={() => navigate("/games")}
                className="my-form-button button-base button-3d font_family_base"
                style={{
                  backgroundImage: `url(${buttonBackground})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "white",
                  fontWeight: 700,
                  width: "200px",
                }}
              >
                View Games
              </button>
              <button
                onClick={() => navigate("/rules")}
                className="my-form-button button-base button-3d font_family_base"
                style={{
                  backgroundImage: `url(${buttonBackground})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "white",
                  fontWeight: 700,
                  width: "200px",
                }}
              >
                Manage Rules
              </button>
              <button
                onClick={() => navigate("/settings")}
                className="my-form-button button-base button-3d font_family_base"
                style={{
                  backgroundImage: `url(${buttonBackground})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "white",
                  fontWeight: 700,
                  width: "200px",
                }}
              >
                Account Settings
              </button>
              <button
                onClick={() => navigate("/contact")}
                className="my-form-button button-base button-3d font_family_base"
                style={{
                  backgroundImage: `url(${buttonBackground})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "white",
                  fontWeight: 700,
                  width: "200px",
                }}
              >
                Contact Support
              </button>
            </div>
          </div>
        </div> */}
      </div>
      <Footer />
    </div>
  );
}
